<template>
  <div>
    <div class="table-content row-data" style="margin-bottom: 20px; width: 1000px">
      <el-table
          style="width: 1000px"
          :empty-text="textTable"
          v-loading="loadingData"
          :element-loading-text="$tableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255, 0)"
          :data="listPhone"
          highlight-current-row
          :header-cell-style="tableHeaderColor"
          @selection-change="handleSelectionChange"
          :max-height="$tableMaxHeight"
          border
      >
        <el-table-column
            fixed
            type="selection"
            width="50"
            align="center"
        ></el-table-column>
        <el-table-column
            fixed
            type="index"
            label="STT"
            width="50"
            align="center"
        ></el-table-column>
        <el-table-column fixed prop="phoneNumber" min-width="150" label="Số điện thoại" align="center">
          <template v-slot:default="scope">
            {{ scope.row.phoneNumber }}
          </template>
        </el-table-column>
        <el-table-column
            label="Tác vụ"
            align="center"
            fixed="right"
            width="200px"
        >
          <template v-slot:default="scope">
            <el-button
                style="margin-left: 20px"
                size="medium"
                type="danger"
                @click="handleDelete(scope.row)"
            >Xóa
            </el-button>
          </template>

        </el-table-column>
      </el-table>
    </div>
    <div style="width: 1000px">
      <el-dropdown @command="handleCommand" style="float: right; margin-top: 10px">
        <el-button class="button-over" type="success">
          Tác vụ
          <i class="el-icon-caret-bottom"/>
        </el-button>
        <el-dropdown-menu class="el-dropdown-menu-container">
          <el-dropdown-item command="createPhone">Thêm SĐT</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <CreateReceiveMessagesSystemDialog
        :isCreate="isCreate"
        :listPhone="listPhone"
        @close="handleCloseCreateReceiveMessagesSystemDialog"
    />
  </div>
</template>

<script>
import CreateReceiveMessagesSystemDialog from "@/views/master/other/CreateReceiveMessagesSystemDialog.vue";
import manageDataService from "@/services/AdminService/ManageDataService";

export default {
  name: "ReceiveMessagesSystem",
  components: {CreateReceiveMessagesSystemDialog},
  data() {
    return {
      textTable: this.$tableEmpty,
      loadingData: true,
      listPhone: [],
      id: 0,
      isCreate: false
    }
  },
  created() {
    this.findAllData()
  },
  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold";
    },

    async findAllData() {
      await manageDataService.getReceiveMessagesSystem().then((response) => {
        this.listPhone = response.data.data;
      }).catch((error) => {
        console.log(error);
      }).finally(
          this.loadingData = false
      )
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCommand(command) {
      if (command === "createPhone") {
        this.showCreateReceiveMessagesSystemDialog()
      }
    },
    showCreateReceiveMessagesSystemDialog() {
      this.isCreate = true;
    },
    handleCloseCreateReceiveMessagesSystemDialog() {
      this.isCreate = false;
      this.findAllData();
    },
    handleDelete(row) {
      this.$confirm(
          "Bạn có chắc chắn muốn xóa số điện thoại đã chọn?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
          }
      ).then(() => {
        manageDataService.deleteReceiveMessagesSystem(row.id)
            .then((res) => {
              if (res.data.data) {
                this.$message({
                  message: "Xóa số điện thoại thành công",
                  type: "success",
                });
                this.findAllData();
              } else {
                this.$message({
                  message: "Xóa hoạt thất bại",
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.right-align {
  text-align: right;
}

.container_nav_page {
  display: flex;
  justify-content: center;
}
</style>

